/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type RehypeBeneficiaryReplaced = {
  rehypeState: Address;
  currentWallet: Address;
  newWallet: Address;
};

export type RehypeBeneficiaryReplacedArgs = RehypeBeneficiaryReplaced;

export function getRehypeBeneficiaryReplacedEncoder(): FixedSizeEncoder<RehypeBeneficiaryReplacedArgs> {
  return getStructEncoder([
    ['rehypeState', getAddressEncoder()],
    ['currentWallet', getAddressEncoder()],
    ['newWallet', getAddressEncoder()],
  ]);
}

export function getRehypeBeneficiaryReplacedDecoder(): FixedSizeDecoder<RehypeBeneficiaryReplaced> {
  return getStructDecoder([
    ['rehypeState', getAddressDecoder()],
    ['currentWallet', getAddressDecoder()],
    ['newWallet', getAddressDecoder()],
  ]);
}

export function getRehypeBeneficiaryReplacedCodec(): FixedSizeCodec<
  RehypeBeneficiaryReplacedArgs,
  RehypeBeneficiaryReplaced
> {
  return combineCodec(
    getRehypeBeneficiaryReplacedEncoder(),
    getRehypeBeneficiaryReplacedDecoder(),
  );
}
